import React, { useMemo, useState } from 'react';
export function App() {
  // Input section (formerly Rooms)
  const [rooms, setRooms] = useState(863); // F1
  const [area, setArea] = useState(37095); // F2
  // Attributes section - master checkbox
  const [attributesEnabled, setAttributesEnabled] = useState(true);
  const [attrRaumstempel, setAttrRaumstempel] = useState(false); // F3
  const [attrExcelFile, setAttrExcelFile] = useState(false); // F4
  const [attrCustomCount, setAttrCustomCount] = useState(false); // New: custom attribute count
  const [customAttrCount, setCustomAttrCount] = useState(1); // Number of attributes
  // Calculate coefficient based on number of attributes
  const calculateAttrCoefficient = (n: number) => {
    if (n === 1) return 0.7;
    if (n === 2) return 0.85;
    if (n === 3) return 1;
    if (n === 4) return 1.2;
    if (n >= 5) return 1.3 + n * 0.1;
    return 0; // for other values
  };
  // Coefficient of difficulty
  const [difficulty, setDifficulty] = useState(1); // F6
  // Source materials (Yes/No) - only one should be selected
  const [srcHandDrawn, setSrcHandDrawn] = useState(false); // F7 = 1.5
  const [srcDWG, setSrcDWG] = useState(true); // F8 = 1.1
  const [srcPointcloud, setSrcPointcloud] = useState(false); // F9 = 2
  const [srcHandDrawnPointcloud, setSrcHandDrawnPointcloud] = useState(false); // F10 = 2.2
  const [srcDWGPointcloud, setSrcDWGPointcloud] = useState(false); // F11 = 1.5
  const [srcIFC, setSrcIFC] = useState(false); // F12 = 0.2
  // Internal section
  const [hourlyRate, setHourlyRate] = useState(55); // E1
  const [provision, setProvision] = useState(0.25); // E2
  const [marge, setMarge] = useState(1.7); // E3
  const [baseWorkspeed, setBaseWorkspeed] = useState(23); // E4
  const [management, setManagement] = useState(1.25); // E5
  // Multiplier values - now editable
  const [F7, setF7] = useState(1.5);
  const [F8, setF8] = useState(1.1);
  const [F9, setF9] = useState(2);
  const [F10, setF10] = useState(2.2);
  const [F11, setF11] = useState(1.5);
  const [F12, setF12] = useState(0.2);
  // Attribute values - now editable
  const [F3_val, setF3_val] = useState(0);
  const [F4_val, setF4_val] = useState(0.6);
  const [F5_val, setF5_val] = useState(0.5);
  const result = useMemo(() => {
    // Get selected source material multiplier
    let sourceMultiplier = 0;
    if (srcHandDrawn) sourceMultiplier = F7;else if (srcDWG) sourceMultiplier = F8;else if (srcPointcloud) sourceMultiplier = F9;else if (srcHandDrawnPointcloud) sourceMultiplier = F10;else if (srcDWGPointcloud) sourceMultiplier = F11;else if (srcIFC) sourceMultiplier = F12;
    // Get attribute time - now uses Result value (includes coefficient if custom count is enabled)
    let attrTime = 0;
    if (attrRaumstempel) attrTime = attrCustomCount ? F4_val * calculateAttrCoefficient(customAttrCount) : F4_val;else if (attrExcelFile) attrTime = attrCustomCount ? F5_val * calculateAttrCoefficient(customAttrCount) : F5_val;
    // Base time calculation
    const baseTime = rooms / baseWorkspeed;
    // Formula: ((F1/E4)*F6*Fx + (F1/E4)*attrTime) * E1 * E5 * E3
    const calculation = (baseTime * difficulty * sourceMultiplier + baseTime * attrTime) * hourlyRate * management * marge;
    return calculation;
  }, [rooms, area, attrRaumstempel, attrExcelFile, difficulty, srcHandDrawn, srcDWG, srcPointcloud, srcHandDrawnPointcloud, srcDWGPointcloud, srcIFC, hourlyRate, provision, marge, baseWorkspeed, management, F3_val, F4_val, F5_val, F7, F8, F9, F10, F11, F12, attrCustomCount, customAttrCount]);
  return <div className="min-h-screen bg-gray-100 p-4 font-sans text-sm" data-id="element-0">
      <div className="max-w-4xl mx-auto bg-white border border-gray-300" data-id="element-1">
        {/* Header */}
        <div className="grid grid-cols-[1fr_150px_150px_150px] border-b border-gray-300 bg-gray-50 text-xs font-medium" data-id="element-2">
          <div className="p-2 border-r border-gray-300" data-id="element-3"></div>
          <div className="p-2 border-r border-gray-300 text-center" data-id="element-4">
            Example value
          </div>
          <div className="p-2 border-r border-gray-300 text-center" data-id="element-5">
            Calculation value
          </div>
          <div className="p-2 text-center" data-id="element-6">Result</div>
        </div>

        {/* Input Section */}
        <div className="border-b border-gray-300" data-id="element-7">
          <div className="grid grid-cols-[1fr_150px_150px_150px] border-b border-gray-200 bg-gray-50" data-id="element-8">
            <div className="p-2 border-r border-gray-300 font-bold border-l-4 border-l-blue-500" data-id="element-9">
              Input
            </div>
            <div className="p-2 border-r border-gray-300" data-id="element-10"></div>
            <div className="p-2 border-r border-gray-300 bg-gray-100" data-id="element-11"></div>
            <div className="p-2 bg-gray-100" data-id="element-12"></div>
          </div>
          <div className="grid grid-cols-[1fr_150px_150px_150px] border-b border-gray-200" data-id="element-13">
            <div className="p-2 border-r border-gray-300 pl-8" data-id="element-14">Rooms</div>
            <div className="p-2 border-r border-gray-300" data-id="element-15">
              <input type="number" value={rooms} onChange={e => setRooms(Number(e.target.value))} className="w-full px-1 py-0.5 border border-gray-300 text-right" data-id="element-16" />
            </div>
            <div className="p-2 border-r border-gray-300 bg-gray-100 text-right" data-id="element-17">
              {rooms}
            </div>
            <div className="p-2 bg-gray-100" data-id="element-18"></div>
          </div>
          <div className="grid grid-cols-[1fr_150px_150px_150px]" data-id="element-19">
            <div className="p-2 border-r border-gray-300 pl-8" data-id="element-20">Area</div>
            <div className="p-2 border-r border-gray-300" data-id="element-21">
              <input type="number" value={area} onChange={e => setArea(Number(e.target.value))} className="w-full px-1 py-0.5 border border-gray-300 text-right" data-id="element-22" />
            </div>
            <div className="p-2 border-r border-gray-300 bg-gray-100 text-right" data-id="element-23">
              {area}
            </div>
            <div className="p-2 bg-gray-100" data-id="element-24"></div>
          </div>
        </div>

        {/* Attributes Section */}
        <div className="border-b border-gray-300" data-id="element-25">
          <div className="grid grid-cols-[1fr_150px_150px_150px] border-b border-gray-200 bg-gray-50" data-id="element-26">
            <div className="p-2 border-r border-gray-300 font-bold border-l-4 border-l-blue-500" data-id="element-27">
              Attributes
            </div>
            <div className="p-2 border-r border-gray-300 text-center" data-id="element-28">
              <input type="checkbox" checked={attributesEnabled} onChange={e => {
              setAttributesEnabled(e.target.checked);
              if (!e.target.checked) {
                setAttrRaumstempel(false);
                setAttrExcelFile(false);
                setAttrCustomCount(false);
              }
            }} className="w-4 h-4" data-id="element-29" />
            </div>
            <div className="p-2 border-r border-gray-300 bg-gray-100 text-right" data-id="element-30"></div>
            <div className="p-2 bg-gray-100" data-id="element-31"></div>
          </div>
          <div className="grid grid-cols-[1fr_150px_150px_150px] border-b border-gray-200" data-id="element-32">
            <div className="p-2 border-r border-gray-300 pl-8" data-id="element-33">
              1. Attributes from space stamp (raumstempel)
            </div>
            <div className="p-2 border-r border-gray-300 text-center" data-id="element-34">
              <input type="checkbox" checked={attrRaumstempel} onChange={e => {
              setAttrRaumstempel(e.target.checked);
              if (e.target.checked) {
                setAttrExcelFile(false);
              }
            }} disabled={!attributesEnabled} className="w-4 h-4 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-35" />
            </div>
            <div className="p-2 border-r border-gray-300 bg-gray-100" data-id="element-36">
              <input type="number" step="0.1" value={F4_val} onChange={e => setF4_val(Number(e.target.value))} className="w-full px-1 py-0.5 border border-gray-300 text-right bg-white" data-id="element-37" />
            </div>
            <div className="p-2 bg-gray-100 text-right" data-id="element-38">
              {attrCustomCount ? (F4_val * calculateAttrCoefficient(customAttrCount)).toFixed(2) : F4_val.toFixed(2)}
            </div>
          </div>
          <div className="grid grid-cols-[1fr_150px_150px_150px] border-t border-gray-200" data-id="element-39">
            <div className="p-2 border-r border-gray-300 pl-8" data-id="element-40">
              2. Excel file
            </div>
            <div className="p-2 border-r border-gray-300 text-center" data-id="element-41">
              <input type="checkbox" checked={attrExcelFile} onChange={e => {
              setAttrExcelFile(e.target.checked);
              if (e.target.checked) {
                setAttrRaumstempel(false);
              }
            }} disabled={!attributesEnabled} className="w-4 h-4 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-42" />
            </div>
            <div className="p-2 border-r border-gray-300 bg-gray-100" data-id="element-43">
              <input type="number" step="0.1" value={F5_val} onChange={e => setF5_val(Number(e.target.value))} className="w-full px-1 py-0.5 border border-gray-300 text-right bg-white" data-id="element-44" />
            </div>
            <div className="p-2 bg-gray-100 text-right" data-id="element-45">
              {attrCustomCount ? (F5_val * calculateAttrCoefficient(customAttrCount)).toFixed(2) : F5_val.toFixed(2)}
            </div>
          </div>
          <div className="grid grid-cols-[1fr_150px_150px_150px] border-t border-gray-200" data-id="element-46">
            <div className="p-2 border-r border-gray-300 pl-8" data-id="element-47">
              3. Custom attribute count
            </div>
            <div className="p-2 border-r border-gray-300 text-center" data-id="element-48">
              <input type="checkbox" checked={attrCustomCount} onChange={e => setAttrCustomCount(e.target.checked)} disabled={!attributesEnabled} className="w-4 h-4 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-49" />
            </div>
            <div className="p-2 border-r border-gray-300 bg-gray-100" data-id="element-50">
              <input type="number" min="1" step="1" value={customAttrCount} onChange={e => setCustomAttrCount(Math.max(1, parseInt(e.target.value) || 1))} disabled={!attrCustomCount} className="w-full px-1 py-0.5 border border-gray-300 text-right bg-white disabled:opacity-50" data-id="element-51" />
            </div>
            <div className="p-2 bg-gray-100 text-right" data-id="element-52">
              {attrCustomCount ? calculateAttrCoefficient(customAttrCount).toFixed(2) : ''}
            </div>
          </div>
        </div>

        {/* Coefficient of difficulty */}
        <div className="border-b border-gray-300" data-id="element-53">
          <div className="grid grid-cols-[1fr_150px_150px_150px] border-b border-gray-200 bg-gray-50" data-id="element-54">
            <div className="p-2 border-r border-gray-300 font-bold border-l-4 border-l-blue-500" data-id="element-55">
              Coefficient of difficulty
            </div>
            <div className="p-2 border-r border-gray-300" data-id="element-56"></div>
            <div className="p-2 border-r border-gray-300 bg-gray-100" data-id="element-57"></div>
            <div className="p-2 bg-gray-100" data-id="element-58"></div>
          </div>
          <div className="grid grid-cols-[1fr_150px_150px_150px]" data-id="element-59">
            <div className="p-2 border-r border-gray-300 pl-8" data-id="element-60"></div>
            <div className="p-2 border-r border-gray-300" data-id="element-61">
              <input type="range" min="0.7" max="1.4" step="0.1" value={difficulty} onChange={e => setDifficulty(Number(e.target.value))} className="w-full" data-id="element-62" />
            </div>
            <div className="p-2 border-r border-gray-300 bg-gray-100 text-right" data-id="element-63">
              {difficulty.toFixed(1)}
            </div>
            <div className="p-2 bg-gray-100" data-id="element-64"></div>
          </div>
        </div>

        {/* Source materials */}
        <div className="border-b border-gray-300" data-id="element-65">
          <div className="grid grid-cols-[1fr_150px_150px_150px] border-b border-gray-200 bg-gray-50" data-id="element-66">
            <div className="p-2 border-r border-gray-300 font-bold border-l-4 border-l-blue-500" data-id="element-67">
              Source materials
            </div>
            <div className="p-2 border-r border-gray-300" data-id="element-68"></div>
            <div className="p-2 border-r border-gray-300 bg-gray-100" data-id="element-69"></div>
            <div className="p-2 bg-gray-100" data-id="element-70"></div>
          </div>
          <div className="grid grid-cols-[1fr_150px_150px_150px] border-b border-gray-200" data-id="element-71">
            <div className="p-2 border-r border-gray-300 pl-8" data-id="element-72">
              1. Plans and sections
            </div>
            <div className="p-2 border-r border-gray-300" data-id="element-73"></div>
            <div className="p-2 border-r border-gray-300 bg-gray-100" data-id="element-74"></div>
            <div className="p-2 bg-gray-100" data-id="element-75"></div>
          </div>
          <div className="grid grid-cols-[1fr_150px_150px_150px] border-b border-gray-200" data-id="element-76">
            <div className="p-2 border-r border-gray-300 pl-16" data-id="element-77">
              1.1. Plans and sections - Hand drawn
            </div>
            <div className="p-2 border-r border-gray-300 text-center" data-id="element-78">
              <input type="checkbox" checked={srcHandDrawn} onChange={e => {
              setSrcHandDrawn(e.target.checked);
              if (e.target.checked) {
                setSrcDWG(false);
                setSrcPointcloud(false);
                setSrcHandDrawnPointcloud(false);
                setSrcDWGPointcloud(false);
                setSrcIFC(false);
              }
            }} className="w-4 h-4" data-id="element-79" />
            </div>
            <div className="p-2 border-r border-gray-300 bg-gray-100" data-id="element-80">
              <input type="number" step="0.1" value={F7} onChange={e => setF7(Number(e.target.value))} className="w-full px-1 py-0.5 border border-gray-300 text-right bg-white" data-id="element-81" />
            </div>
            <div className="p-2 bg-gray-100 text-right" data-id="element-82">
              {(() => {
              const baseTime = rooms / baseWorkspeed;
              const attrTime = attrRaumstempel ? attrCustomCount ? F4_val * calculateAttrCoefficient(customAttrCount) : F4_val : attrExcelFile ? attrCustomCount ? F5_val * calculateAttrCoefficient(customAttrCount) : F5_val : 0;
              return ((baseTime * difficulty * F7 + baseTime * attrTime) * hourlyRate * management * marge).toFixed(2);
            })()}
            </div>
          </div>
          <div className="grid grid-cols-[1fr_150px_150px_150px] border-b border-gray-200" data-id="element-83">
            <div className="p-2 border-r border-gray-300 pl-16" data-id="element-84">
              1.2. Plans and sections - DWG
            </div>
            <div className="p-2 border-r border-gray-300 text-center" data-id="element-85">
              <input type="checkbox" checked={srcDWG} onChange={e => {
              setSrcDWG(e.target.checked);
              if (e.target.checked) {
                setSrcHandDrawn(false);
                setSrcPointcloud(false);
                setSrcHandDrawnPointcloud(false);
                setSrcDWGPointcloud(false);
                setSrcIFC(false);
              }
            }} className="w-4 h-4" data-id="element-86" />
            </div>
            <div className="p-2 border-r border-gray-300 bg-gray-100" data-id="element-87">
              <input type="number" step="0.1" value={F8} onChange={e => setF8(Number(e.target.value))} className="w-full px-1 py-0.5 border border-gray-300 text-right bg-white" data-id="element-88" />
            </div>
            <div className="p-2 bg-gray-100 text-right" data-id="element-89">
              {(() => {
              const baseTime = rooms / baseWorkspeed;
              const attrTime = attrRaumstempel ? attrCustomCount ? F4_val * calculateAttrCoefficient(customAttrCount) : F4_val : attrExcelFile ? attrCustomCount ? F5_val * calculateAttrCoefficient(customAttrCount) : F5_val : 0;
              return ((baseTime * difficulty * F8 + baseTime * attrTime) * hourlyRate * management * marge).toFixed(2);
            })()}
            </div>
          </div>
          <div className="grid grid-cols-[1fr_150px_150px_150px] border-b border-gray-200" data-id="element-90">
            <div className="p-2 border-r border-gray-300 pl-8" data-id="element-91">
              2. Pointcloud
            </div>
            <div className="p-2 border-r border-gray-300 text-center" data-id="element-92">
              <input type="checkbox" checked={srcPointcloud} onChange={e => {
              setSrcPointcloud(e.target.checked);
              if (e.target.checked) {
                setSrcHandDrawn(false);
                setSrcDWG(false);
                setSrcHandDrawnPointcloud(false);
                setSrcDWGPointcloud(false);
                setSrcIFC(false);
              }
            }} className="w-4 h-4" data-id="element-93" />
            </div>
            <div className="p-2 border-r border-gray-300 bg-gray-100" data-id="element-94">
              <input type="number" step="0.1" value={F9} onChange={e => setF9(Number(e.target.value))} className="w-full px-1 py-0.5 border border-gray-300 text-right bg-white" data-id="element-95" />
            </div>
            <div className="p-2 bg-gray-100 text-right" data-id="element-96">
              {(() => {
              const baseTime = rooms / baseWorkspeed;
              const attrTime = attrRaumstempel ? attrCustomCount ? F4_val * calculateAttrCoefficient(customAttrCount) : F4_val : attrExcelFile ? attrCustomCount ? F5_val * calculateAttrCoefficient(customAttrCount) : F5_val : 0;
              return ((baseTime * difficulty * F9 + baseTime * attrTime) * hourlyRate * management * marge).toFixed(2);
            })()}
            </div>
          </div>
          <div className="grid grid-cols-[1fr_150px_150px_150px] border-b border-gray-200" data-id="element-97">
            <div className="p-2 border-r border-gray-300 pl-8" data-id="element-98">
              3. Plans and sections - Pointcloud
            </div>
            <div className="p-2 border-r border-gray-300" data-id="element-99"></div>
            <div className="p-2 border-r border-gray-300 bg-gray-100 text-right" data-id="element-100">
              0
            </div>
            <div className="p-2 bg-gray-100" data-id="element-101"></div>
          </div>
          <div className="grid grid-cols-[1fr_150px_150px_150px] border-b border-gray-200" data-id="element-102">
            <div className="p-2 border-r border-gray-300 pl-16" data-id="element-103">
              3.1. Plans and sections - Hand drawn + Pointcloud
            </div>
            <div className="p-2 border-r border-gray-300 text-center" data-id="element-104">
              <input type="checkbox" checked={srcHandDrawnPointcloud} onChange={e => {
              setSrcHandDrawnPointcloud(e.target.checked);
              if (e.target.checked) {
                setSrcHandDrawn(false);
                setSrcDWG(false);
                setSrcPointcloud(false);
                setSrcDWGPointcloud(false);
                setSrcIFC(false);
              }
            }} className="w-4 h-4" data-id="element-105" />
            </div>
            <div className="p-2 border-r border-gray-300 bg-gray-100" data-id="element-106">
              <input type="number" step="0.1" value={F10} onChange={e => setF10(Number(e.target.value))} className="w-full px-1 py-0.5 border border-gray-300 text-right bg-white" data-id="element-107" />
            </div>
            <div className="p-2 bg-gray-100 text-right" data-id="element-108">
              {(() => {
              const baseTime = rooms / baseWorkspeed;
              const attrTime = attrRaumstempel ? attrCustomCount ? F4_val * calculateAttrCoefficient(customAttrCount) : F4_val : attrExcelFile ? attrCustomCount ? F5_val * calculateAttrCoefficient(customAttrCount) : F5_val : 0;
              return ((baseTime * difficulty * F10 + baseTime * attrTime) * hourlyRate * management * marge).toFixed(2);
            })()}
            </div>
          </div>
          <div className="grid grid-cols-[1fr_150px_150px_150px] border-b border-gray-200" data-id="element-109">
            <div className="p-2 border-r border-gray-300 pl-16" data-id="element-110">
              3.2. Plans and sections - DWG + Pointcloud
            </div>
            <div className="p-2 border-r border-gray-300 text-center" data-id="element-111">
              <input type="checkbox" checked={srcDWGPointcloud} onChange={e => {
              setSrcDWGPointcloud(e.target.checked);
              if (e.target.checked) {
                setSrcHandDrawn(false);
                setSrcDWG(false);
                setSrcPointcloud(false);
                setSrcHandDrawnPointcloud(false);
                setSrcIFC(false);
              }
            }} className="w-4 h-4" data-id="element-112" />
            </div>
            <div className="p-2 border-r border-gray-300 bg-gray-100" data-id="element-113">
              <input type="number" step="0.1" value={F11} onChange={e => setF11(Number(e.target.value))} className="w-full px-1 py-0.5 border border-gray-300 text-right bg-white" data-id="element-114" />
            </div>
            <div className="p-2 bg-gray-100 text-right" data-id="element-115">
              {(() => {
              const baseTime = rooms / baseWorkspeed;
              const attrTime = attrRaumstempel ? attrCustomCount ? F4_val * calculateAttrCoefficient(customAttrCount) : F4_val : attrExcelFile ? attrCustomCount ? F5_val * calculateAttrCoefficient(customAttrCount) : F5_val : 0;
              return ((baseTime * difficulty * F11 + baseTime * attrTime) * hourlyRate * management * marge).toFixed(2);
            })()}
            </div>
          </div>
          <div className="grid grid-cols-[1fr_150px_150px_150px]" data-id="element-116">
            <div className="p-2 border-r border-gray-300 pl-8" data-id="element-117">
              4. IFC import
            </div>
            <div className="p-2 border-r border-gray-300 text-center" data-id="element-118">
              <input type="checkbox" checked={srcIFC} onChange={e => {
              setSrcIFC(e.target.checked);
              if (e.target.checked) {
                setSrcHandDrawn(false);
                setSrcDWG(false);
                setSrcPointcloud(false);
                setSrcHandDrawnPointcloud(false);
                setSrcDWGPointcloud(false);
              }
            }} className="w-4 h-4" data-id="element-119" />
            </div>
            <div className="p-2 border-r border-gray-300 bg-gray-100" data-id="element-120">
              <input type="number" step="0.1" value={F12} onChange={e => setF12(Number(e.target.value))} className="w-full px-1 py-0.5 border border-gray-300 text-right bg-white" data-id="element-121" />
            </div>
            <div className="p-2 bg-gray-100 text-right" data-id="element-122">
              {(() => {
              const baseTime = rooms / baseWorkspeed;
              const attrTime = attrRaumstempel ? attrCustomCount ? F4_val * calculateAttrCoefficient(customAttrCount) : F4_val : attrExcelFile ? attrCustomCount ? F5_val * calculateAttrCoefficient(customAttrCount) : F5_val : 0;
              return ((baseTime * difficulty * F12 + baseTime * attrTime) * hourlyRate * management * marge).toFixed(2);
            })()}
            </div>
          </div>
        </div>

        {/* Internal */}
        <div className="border-b border-gray-300" data-id="element-123">
          <div className="grid grid-cols-[1fr_150px_150px_150px] border-b border-gray-200 bg-gray-50" data-id="element-124">
            <div className="p-2 border-r border-gray-300 font-bold border-l-4 border-l-blue-500" data-id="element-125">
              Internal
            </div>
            <div className="p-2 border-r border-gray-300" data-id="element-126"></div>
            <div className="p-2 border-r border-gray-300 bg-gray-100" data-id="element-127"></div>
            <div className="p-2 bg-gray-100" data-id="element-128"></div>
          </div>
          <div className="grid grid-cols-[1fr_150px_150px_150px] border-b border-gray-200 bg-gray-100" data-id="element-129">
            <div className="p-2 border-r border-gray-300 pl-8" data-id="element-130">
              Internal hourly rate
            </div>
            <div className="p-2 border-r border-gray-300" data-id="element-131"></div>
            <div className="p-2 border-r border-gray-300" data-id="element-132">
              <input type="number" step="0.01" value={hourlyRate} onChange={e => setHourlyRate(Number(e.target.value))} className="w-full px-1 py-0.5 border border-gray-300 text-right bg-white" data-id="element-133" />
            </div>
            <div className="p-2" data-id="element-134"></div>
          </div>
          <div className="grid grid-cols-[1fr_150px_150px_150px] border-b border-gray-200 bg-gray-100" data-id="element-135">
            <div className="p-2 border-r border-gray-300 pl-8" data-id="element-136">Provision</div>
            <div className="p-2 border-r border-gray-300 text-right text-gray-600" data-id="element-137">
              {(0.0932320442 * result).toFixed(2)}
            </div>
            <div className="p-2 border-r border-gray-300" data-id="element-138">
              <input type="number" step="0.01" value={provision} onChange={e => setProvision(Number(e.target.value))} className="w-full px-1 py-0.5 border border-gray-300 text-right bg-white" data-id="element-139" />
            </div>
            <div className="p-2" data-id="element-140"></div>
          </div>
          <div className="grid grid-cols-[1fr_150px_150px_150px] border-b border-gray-200 bg-gray-100" data-id="element-141">
            <div className="p-2 border-r border-gray-300 pl-8" data-id="element-142">Marge</div>
            <div className="p-2 border-r border-gray-300 text-right text-gray-600" data-id="element-143">
              {(0.3729281768 * result).toFixed(2)}
            </div>
            <div className="p-2 border-r border-gray-300" data-id="element-144">
              <input type="number" step="0.01" value={marge} onChange={e => setMarge(Number(e.target.value))} className="w-full px-1 py-0.5 border border-gray-300 text-right bg-white" data-id="element-145" />
            </div>
            <div className="p-2" data-id="element-146"></div>
          </div>
          <div className="grid grid-cols-[1fr_150px_150px_150px] border-b border-gray-200 bg-gray-100" data-id="element-147">
            <div className="p-2 border-r border-gray-300 pl-8" data-id="element-148">Part ioLabs</div>
            <div className="p-2 border-r border-gray-300 text-right text-gray-600" data-id="element-149">
              {(0.2796961326 * result).toFixed(2)}
            </div>
            <div className="p-2 border-r border-gray-300" data-id="element-150"></div>
            <div className="p-2" data-id="element-151"></div>
          </div>
          <div className="grid grid-cols-[1fr_150px_150px_150px] border-b border-gray-200 bg-gray-100" data-id="element-152">
            <div className="p-2 border-r border-gray-300 pl-8" data-id="element-153">
              Base workspeed [rooms/h]
            </div>
            <div className="p-2 border-r border-gray-300" data-id="element-154"></div>
            <div className="p-2 border-r border-gray-300" data-id="element-155">
              <input type="number" step="0.01" value={baseWorkspeed} onChange={e => setBaseWorkspeed(Number(e.target.value))} className="w-full px-1 py-0.5 border border-gray-300 text-right bg-white" data-id="element-156" />
            </div>
            <div className="p-2" data-id="element-157"></div>
          </div>
          <div className="grid grid-cols-[1fr_150px_150px_150px] bg-gray-100" data-id="element-158">
            <div className="p-2 border-r border-gray-300 pl-8" data-id="element-159">Management</div>
            <div className="p-2 border-r border-gray-300" data-id="element-160"></div>
            <div className="p-2 border-r border-gray-300" data-id="element-161">
              <input type="number" step="0.01" value={management} onChange={e => setManagement(Number(e.target.value))} className="w-full px-1 py-0.5 border border-gray-300 text-right bg-white" data-id="element-162" />
            </div>
            <div className="p-2" data-id="element-163"></div>
          </div>
        </div>

        {/* Result */}
        <div className="" data-id="element-164">
          <div className="grid grid-cols-[1fr_150px_150px_150px]" data-id="element-165">
            <div className="p-2 border-r border-gray-300" data-id="element-166"></div>
            <div className="p-2 border-r border-gray-300" data-id="element-167"></div>
            <div className="p-2 border-r border-gray-300 bg-green-100 text-right font-bold text-green-800 text-lg" data-id="element-168">
              {result.toFixed(2)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}